import { useState } from "react";
import { FaBuilding } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useFirmDetail from "../../../Hooks/dealerRoles/useFirmDetail";
import useAuth from "../../../Hooks/useAuth";
import usePermission from "../../../Hooks/usePermission";
import FirmTabContent from "../../../Components/Firm/dealerRoles/FirmTabContent";
import FirmDetailHeaderContent from "../../../Components/Firm/FirmDetailHeaderContent";
import FirmAutoReportDrawer from "../../../Components/Firm/Tabs/FirmAutoReportDrawer";
import FirmBusyBadge from "../../../Components/Firm/FirmBusyBadge";
import useFirmBusy from "../../../Hooks/dealerRoles/useFirmBusy";
import Page403 from "../../Page403";
import {
  DetailShell,
  DetailHeader,
  DetailTabs,
  DetailSkeleton,
  DetailNotFound,
} from "../../../Components/shared";

export default function DealerFirmDetailPage() {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { hasPermission } = usePermission();
  const [reportDrawerOpen, setReportDrawerOpen] = useState(false);
  const {
    firm,
    isOwnDealerFirm,
    isFetching,
    isLoading,
    selectedTab,
    setSelectedTab,
    tabs,
    firmTypeBadge,
    firmIcon,
    alerts,
    dismissAlert,
    handleFirmUpdate,
    handleGoBack,
    handleNavigateToFirm,
  } = useFirmDetail();
  // Firmada işlem sürüyorsa her sekmede başlıkta görünür (#303). Hook erken
  // return'lerden önce çağrılır.
  const { isBusy } = useFirmBusy(firm?._id ? [firm._id] : []);
  const firmBusy = isBusy(firm?._id);

  if (!firm && isLoading) {
    return <DetailSkeleton tabCount={8} sectionRows={[6, 3]} />;
  }

  if (!firm && !isLoading) {
    return (
      <DetailNotFound
        icon={FaBuilding}
        title="Firma Bulunamadı"
        message="İstenen firma bilgilerine ulaşılamadı."
        backLabel="Firmalara Dön"
        onGoBack={() => navigate("/Anasayfa/Firma")}
      />
    );
  }

  return (
    <DetailShell alerts={alerts} onDismissAlert={dismissAlert}>
      <DetailHeader onGoBack={handleGoBack} backTitle="Firmalara Dön">
        <FirmDetailHeaderContent
          firm={firm}
          firmIcon={firmIcon}
          firmTypeBadge={firmTypeBadge}
          isFetching={isFetching}
        />
        {firmBusy && <FirmBusyBadge className="ml-2 shrink-0" />}
      </DetailHeader>

      <DetailTabs tabs={tabs} activeTab={selectedTab} onChange={setSelectedTab} />

      {/* Hiçbir sekmeye izin yoksa içerik BASILMAMALI: selectedTab başlangıç
          değerinde ("info") takılı kaldığı için sekme çubuğu boş olsa bile
          Bilgi sekmesinin içeriği render ediliyordu (kullanıcı bildirimi). */}
      {tabs.length === 0 ? (
        <Page403 />
      ) : (
      <FirmTabContent
        selectedTab={selectedTab}
        firm={firm}
        onFirmUpdate={handleFirmUpdate}
        onNavigateToFirm={handleNavigateToFirm}
        isOwnDealerFirm={isOwnDealerFirm}
        onOpenReportSettings={
          // Depo sayfasında bu kontrol vardı, bayide yoktu: yetkisiz bayi
          // kullanıcısı otomatik rapor çekmecesini açabiliyordu (sunucu PATCH'i
          // reddediyordu ama arayüz izin veriyordu).
          // Müşteri ve (#209) alt bayi firmaları — izin firma tipine göre.
          (firm.firmType === "customer"
            ? hasPermission("customers.editAutoReport")
            : firm.firmType === "dealer" && hasPermission("dealers.editAutoReport"))
            ? () => setReportDrawerOpen(true)
            : undefined
        }
      />
      )}

      <FirmAutoReportDrawer
        open={reportDrawerOpen}
        onClose={() => setReportDrawerOpen(false)}
        firm={firm}
        token={auth?.accessToken}
      />
    </DetailShell>
  );
}
